import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DropdownLanguage, LanguageDto } from '../interfaces';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { sortBy } from 'underscore';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LanguagesService {
  private iAdminURL;

  constructor(private http: HttpClient) {
    const config = environment;
    this.iAdminURL = config.iAdminApiBaseURL;
  }

  public fetchLanguages(): Observable<LanguageDto[]> {
    return this.http.get<LanguageDto[]>(`${this.iAdminURL}/Global/Langues`);
  }

  public fetchMappedLanguagesToPrimeNGDropdowns(): Observable<DropdownLanguage[]> {
    return this.fetchLanguages().pipe(
      map((res: LanguageDto[]) => {
        let mappedLanguageArray: DropdownLanguage[] = [];

        res.forEach((lan: LanguageDto) => {
          let mappedLanguage: DropdownLanguage = {} as DropdownLanguage;
          mappedLanguage = { ...lan, value: lan.id, label: lan.description };
          mappedLanguageArray.push(mappedLanguage);
        });

        mappedLanguageArray = sortBy(mappedLanguageArray, 'label');

        return mappedLanguageArray;
      })
    );
  }
}
